export enum TransactionTypeEnum {
	ATM_CASH_DEPOSIT = 'ATM Cash Deposit',
	ATM_WITHDROWAL = 'ATM Withdrawal',
	BUY_CURRENCY = 'Buy Currency',
	CASH_DEPOSIT = 'Cash Deposit',
	CASH_WITHDRAWAL = 'Cash Withdrawals',
	CASHED_CHECK = 'Cashed Check',
	CASHIERS_CHECK = "Cashier's Check",
	CHECK = 'Check',
	CHECK_DEPOSIT = 'Check Deposit',
	DEBIT_CARD = 'Debit Card',
	DEBIT_CARD_RETURN = 'Debit Card Return',
	DOMESTIC_WIRE = 'Domestic Wire',
	EXTERNAL_TRANSFER = 'External Transfer',
	INTERNAL_TRANSFER = 'Internal Transfer',
	INTERNATIONAL_ACH = 'International ACH',
	INTERNATIONAL_ATM_WITHDRAWAL = 'International ATM Withdrawal',
	INTERNATIONAL_WIRE = 'International Wire',
	MISCELLANEOUS = 'Miscellaneous',
	MISCELLANEOUS_OFFLINE_TRANSACTION = 'Miscellaneous Offline Transaction',
	ZELLE_TRANSFER = 'Zelle Transfer',
	PAYPAL_TRANSFER = 'PayPal Transfer',
	CASHAPP_TRANSFER = 'Cash App Transfer',
}

export interface InvestigationTransaction {
	transactionKey: string;
	accountKey: string;
	executionLocalDateTime: string;
	acctCurrAmount: string;
	transactionCodeCode: string;
	additionalMessageInfo: string;
	narrative: string;
	oppAccountKey: string;
	oppAccountNumber: string;
	oppOrganizationKey: string;
	crDrInd: string;
	description: string;
	oppWireParty: string;
	oppPartyName?: string;
	transactionType: TransactionTypeEnum;
}
